export default __webpack_public_path__ + "static/media/question8-mobile.298b592b.svg";